module.exports = __webpack_public_path__ + "static/media/dashboardsvg.115cf443.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_assets/icons/dashboardsvg.svg
// module id = 729
// module chunks = 0